export const UPDATE_HOME = 'UPDATE_HOME'



// WEBPACK FOOTER //
// ./src/store/huichang/mutation-types.js